

const StdValueCell = (props) => {
    return (
        <td className="py-3 px-4 text-left">
            {props.children}
        </td>
    );
};

export default StdValueCell;
